import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { LinearProgress, Link } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectedUserIdSelector } from '../../../../selectors/userSelectors';
import { useGetFilesQuery } from '../../../../api/filesApi';

const FileSection = () => {
  const selectedUserId = useSelector(selectedUserIdSelector);
  const { data: files = [], error, isLoading } = useGetFilesQuery(selectedUserId);

  if (error) {
    return <div>{error.message}</div>;
  }

  const columns = [
    {
      field: 'createdAt',
      headerName: 'Upload Date',
      type: 'dateTime',
      valueGetter: (_value, file) => file.createdAt && new Date(file.createdAt),
      minWidth: 170
    },
    {
      field: 'taxYear',
      headerName: 'Tax Year',
      minWidth: 70
    },
    {
      field: 'collectionType',
      headerName: 'Collection Type',
      minWidth: 160
    },
    {
      field: 'fileName',
      headerName: 'Filename',
      minWidth: 370
    },
    {
      field: 'signedUrl',
      headerName: 'Link',
      renderCell: (params) => {
        const file = params.row;

        return (
          <Link href={file.signedUrl} target='_blank' rel='noopener noreferrer'>
            {file.thumbnailSignedUrl ? <img src={file.thumbnailSignedUrl} alt={file.fileName} height={50} /> : 'Link'}
          </Link>
        );
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 70
    },
    {
      field: 'page',
      headerName: 'Page'
    }
  ];

  return (
    <DataGrid
      slotProps={{ root: { 'data-testid': 'file-section' } }}
      rows={files}
      slots={{
        loadingOverlay: LinearProgress
      }}
      columns={columns}
      loading={isLoading}
      autosizeOnMount
      autoPageSize
      initialState={{
        sorting: {
          sortModel: [{ field: 'createdAt', sort: 'desc' }]
        }
      }}
    />
  );
};

export default FileSection;
